import React from "react";
import { Modal } from "react-bootstrap";
import Resources from "../../types/Resources";
import TextInput from "../Common/TextInput";
import LabelCheckbox from "../Common/LabelCheckbox";
import { CompanyDepartmentFormState } from "../../types/forms/CompanyDepartmentFormState";
import Button from "../Common/Button";
import LoadingSpinner from "../Common/LoadingSpinner";

type Props = {
    show: boolean;
    modalHeader: string;
    resources: Resources;
    formState: CompanyDepartmentFormState;
    canManageIsEnergyHarbourCustomer: boolean;
    disableSubmit: boolean;
    isLoading: boolean;
    onNameChange: (name: string) => void;
    onIsEnergyHarbourCustomerChange: (isChecked: boolean) => void;
    onSubmit: (e: React.FormEvent) => void;
    onHide: () => void;
};

function CompanyDepartmentFormModal(props: Props) {
    return (
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{props.modalHeader}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <form onSubmit={props.onSubmit}>
                        <TextInput
                            inputId="company-department-name"
                            labelText={props.resources.get("DepartmentName")}
                            value={props.formState.name.value}
                            onChange={props.onNameChange}
                            readOnly={false}
                            errorMessage={props.formState.name.errorMessage}
                            boldLabel={false}
                        />

                        <LabelCheckbox
                            checked={props.formState.isEnergyHarbourCustomer.value}
                            label={props.resources.get("IsEnergyHarbourCustomer")}
                            onChange={props.onIsEnergyHarbourCustomerChange}
                            id="is-energy-harbour-customer-checkbox"
                            tooltip={props.resources.get("IsEnergyHarbourCustomerTooltip")}
                            readOnly={!props.canManageIsEnergyHarbourCustomer}
                            containerClassName="mt-2"
                        />

                        <Button type="submit" className="w-100 mt-3" disabled={props.disableSubmit}>
                            {props.resources.get("Save")}
                        </Button>
                    </form>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default CompanyDepartmentFormModal;
